export enum AggFunc {
  sum = 'sum',
  sumInteger = 'sumInteger',
  count = 'count',
  avg = 'avg',
  min = 'min',
  max = 'max',
  first = 'first',
  last = 'last',
  groupSum = 'groupSum',
  // The column's customAggFunc (Margin % from its parts), for a grid with rowGrouping on.
  custom = 'custom',
}
